(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("examples", [], factory);
	else if(typeof exports === 'object')
		exports["examples"] = factory();
	else
		root["examples"] = factory();
})(globalThis, () => {
return 